__turbopack_context__.v({
  "BasePageWrap": "mC5SQW_BasePageWrap",
  "FooterHr": "mC5SQW_FooterHr",
  "NavDesktop": "mC5SQW_NavDesktop",
  "NavMobile": "mC5SQW_NavMobile",
  "Root": "mC5SQW_Root",
  "White": "mC5SQW_White",
  "WhoWeArePage": "mC5SQW_WhoWeArePage",
});
